import {gql} from '@apollo/client/core';

export const profileUpcomingOrderQuery = gql`
  query ProfileUpcomingOrderQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          status
          discounts {
            title
            amount
            type
            category
            productVariantId
          }
        }
        upcomingOrder {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discountTotal
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
          }
        }
      }
    }
  }
`;

export const profileCustomerSubscriptionQuery = gql`
  query ProfileCustomerSubscriptionQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          status
          hasMembership
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
        }
        upcomingOrder {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discountTotal
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
          }
        }
        orders {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
            isMembership
          }
        }
      }
    }
  }
`;

export const profileRecentOrdersQuery = gql`
  query ProfileRecentOrdersQuery {
    me {
      id
      customerAccount {
        id
        orders {
          id
          name
          billingDate
          status
          subTotal
          discountTotal
          taxTotal
          shippingTotal
          total
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
            isMembership
          }
        }
      }
    }
  }
`;
export const storeQuery = gql`
  query StoreQuery {
    store {
      products {
        id
        tid
        title
        category
        thumbnail
        displayOrder
        variantIds
      }
      productVariants {
        id
        tid
        sku
        title
        type
        price
        packageType
        productId
        product {
          id
          tid
          title
          category
          thumbnail
          displayOrder
          displayTheme
          variantIds
        }
      }
    }
  }
`;

export const UpdateCustomerAddressMutation = gql`
  mutation UpdateCustomerAddressMutation($input: UpdateShippingAddressInput!) {
    updateCustomerAccountShippingAddress(input: $input) {
      address
      addressDetail
      city
      countryCode
      provinceCode
      postalCode
      firstName
      lastName
    }
  }
`;

export const sendPaymentMethodUpdateLinkMutation = gql`
  mutation SendPaymentMethodUpdateLinkMutation {
    sendPaymentMethodUpdateLink {
      success
      code
      message
    }
  }
`;

export const UpdateSubscriptionMutation = gql`
  mutation UpdateSubscriptionMutation($subscriptionChanges: UpdateSubscriptionInput!) {
    updateSubscription(subscriptionChanges: $subscriptionChanges) {
      id
    }
  }
`;
